import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { useViewport } from '../../hooks/useViewport';

interface SentimentGaugeProps {
  score: number; // 0-100
  size?: number;
  showLabel?: boolean;
}

const SentimentGauge: React.FC<SentimentGaugeProps> = ({ score, size, showLabel = true }) => {
  const { isMobile, isTablet } = useViewport();

  // Responsive size - use prop if provided, otherwise calculate based on viewport
  const responsiveSize = size ?? (isMobile ? 150 : isTablet ? 180 : 200);

  const getColor = (score: number): string => {
    if (score >= 70) return '#10b981'; // green
    if (score >= 40) return '#f59e0b'; // yellow
    return '#ef4444'; // red
  };

  const getStatus = (score: number): string => {
    if (score >= 70) return 'Excellent';
    if (score >= 40) return 'Good';
    return 'Needs Attention';
  };

  const data = [
    { name: 'score', value: score },
    { name: 'remaining', value: 100 - score },
  ];

  const color = getColor(score);

  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ width: responsiveSize, height: responsiveSize }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              startAngle={180}
              endAngle={0}
              innerRadius="70%"
              outerRadius="100%"
              paddingAngle={0}
              dataKey="value"
            >
              <Cell fill={color} />
              <Cell fill="#e5e7eb" />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="font-['Ovo'] text-3xl sm:text-4xl text-[#1f1f1f]">{score}</div>
          <div className="font-['Open_Sans'] text-xs sm:text-sm text-[#767472]">out of 100</div>
        </div>
      </div>
      {showLabel && (
        <div className="mt-2 sm:mt-4 text-center">
          <div className="font-['Open_Sans'] text-xs sm:text-sm font-semibold" style={{ color }}>
            {getStatus(score)}
          </div>
        </div>
      )}
    </div>
  );
};

export default SentimentGauge;
